import { useLoaderData } from "react-router-dom";
import { ListingDetailsView } from "../components/ListingDetailsView";
import type { UnitPlanDetailsPageLoaderType } from "./loaders/UnitPlanDetailsPageLoader";

export const UnitPlanDetailsPage: React.FC = () => {
  const details = useLoaderData() as UnitPlanDetailsPageLoaderType;
  return <ListingDetailsView details={details} />;
};
